import { extractLastNameComponent } from '@spotify/confidence-core-react';
import {
  ActivityChangeOptions,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';
import { useIdentity } from '@spotify/plugin-confidence-iam-react';
import { createMetricUpdatesChangeExtension } from '@spotify/plugin-confidence-metrics-react';

const useDisplayName = (identityName: string | null | undefined): string => {
  const { identity } = useIdentity({
    name: identityName ?? '',
    skip: !identityName,
  });
  return (
    identity?.displayName ??
    extractLastNameComponent(identityName ?? '') ??
    'Unknown'
  );
};

const OwnerChangeRender = ({ change }: ActivityChangeOptions) => {
  const oldName = useDisplayName(change.oldValue);
  const newName = useDisplayName(change.newValue);

  return <ActivityTagItem oldValue={oldName} newValue={newName} />;
};

export const METRIC_OWNER_CHANGE_EXTENSION = createMetricUpdatesChangeExtension(
  {
    id: 'metric-owner-change',
    predicate: ({ change }) => change.fieldPath === '/owner',
    title: () => 'Transferred ownership',
    render: OwnerChangeRender,
  },
);
